<script>
import ModifyButtons from "@/components/ModifyButtons";
import TextInput from "@/components/TextInput";
import ErrorMessage from "@/components/ErrorMessage";
import bus from "@/bus";
import { useResourcesStore } from "../../stores/resources";

export default {
  setup() {
    const resourceStore = useResourcesStore();
    return { resourceStore };
  },
  components: {
    TextInput,
    ModifyButtons,
    ErrorMessage,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      communeDropdownExpanded: false,
      lastname: this.params.lastname,
      firstname: this.params.firstname,
      email: this.params.email,
      id: this.params.id,
      errors: [],
      role: "Admin",
    };
  },
  methods: {
    closeMessage(id) {
      Object.keys(this.errors).forEach((key) => {
        if (id === this.errors[key].id) {
          this.errors.splice(key, 1);
        }
      });
    },
    async modify() {
      const { id, firstname, lastname, email, role } = this;

      const error = await this.resourceStore.updateAccount({
        id,
        type: "admin",
        data: {
          firstname:
            firstname !== this.params.firstname ? firstname : undefined,
          lastname: lastname !== this.params.lastname ? lastname : undefined,
          email: email !== this.params.email ? email : undefined,
          role,
        },
      });
      if (error) {
        this.errors.push({
          id: Date.now(),
          message: error.data.message,
        });
      } else {
        this.close();
      }
    },
    async deleteAccount() {
      const error = await this.resourceStore.deleteAccount({
        id: this.id,
        type: "admin",
      });
      if (error) {
        this.errors.push({
          id: Date.now(),
          message: error.data.message,
        });
      } else {
        this.close();
      }
    },
    close() {
      bus.emit("closeModal");
    },
  },
};
</script>

<template>
  <div class="p-8 z-50 bg-white shadow-xl rounded sm:min-w-md sm:max-w-md">
    <header class="text-xl text-gray-700 font-bold pb-5">
      <span>{{ $t("views.modals.modify_admin.edit") }}</span>
    </header>

    <div v-for="msg in errors" :key="msg.id">
      <ErrorMessage :value="msg" @input="closeMessage" />
    </div>

    <TextInput id="nom" v-model="lastname" data-cy="lastname" :label="$t('views.modals.modify_admin.last_name')"
      type="text" class="mb-4" />
    <TextInput id="prenom" v-model="firstname" data-cy="firstname" :label="$t('views.modals.modify_admin.first_name')"
      type="text" class="mb-4" />

    <TextInput id="mail" v-model="email" data-cy="email" :label="$t('views.modals.modify_admin.email')" type="email"
      class="mb-4" />

    <select v-model="role" class="mb-4 p-2 text-gray-700 rounded border border-gray-300 bg-white">
      <option value="User">
        {{ $t("views.modals.modify_admin.commune_account") }}
      </option>
      <option value="Admin" selected>
        {{ $t("views.modals.modify_admin.admin_account") }}
      </option>
    </select>

    <ModifyButtons @modify="modify" @close="close" @delete="deleteAccount" />
  </div>
</template>
